import React from 'react';
import styled from 'styled-components/macro';
import { getTranslation, LocaleType } from '../utils/getTranslations';
import OpenQuestionElement from './OpenQuestionElement';
import { OpenQuestionType } from './OpenQuestionElement';

const OpenQuestionContainer = styled.div``;

interface OpenQuestionPropsType {
  data: OpenQuestionType[];
  locale: LocaleType;
}

const OpenQuestion = ({ data, locale }: OpenQuestionPropsType) => {
  return (
    <OpenQuestionContainer>
      {data.map((element, idx) => {
        return (
          <OpenQuestionElement
            element={element}
            key={`${getTranslation(element.question, locale)}-${idx}`}
            locale={locale}
          />
        );
      })}
    </OpenQuestionContainer>
  );
};

export default OpenQuestion;
